import React from "react";
import { CommentReference, FileReference, LinkReference } from "../../amorg-common";
import { CardVariant } from "../Card";
import { PageSectionTabs } from "../PageSectionTabs";
import { ReferenceFilesPanel } from "./ReferenceFilesPanel";
import { ReferenceLinksPanel } from "./ReferenceLinksPanel";
import { TabItem2 } from "../Tabber2";
import { Button } from "../button/Button";
import { CommentDrawer } from "./CommentsDrawer";


type FileLinkCommentPageSectionProps = {
    fileReference?: FileReference,
    linkReference?: LinkReference,
    commentReference?: CommentReference,
    cardVariant?: CardVariant,
    selectedTab?: 'files' | 'links',
    onCollapsedChanged?: (collapsed: boolean) => void,
};
export function FileLinkCommentPageSection (props: FileLinkCommentPageSectionProps): JSX.Element
{
    const [selectedTab, setSelectedTab] = React.useState<'files' | 'links' | 'comments'>(
        props.fileReference
            ? 'files'
            : props.linkReference
                ? 'links'
                : 'comments'
    );
    const [showComments, setShowComments] = React.useState<boolean>(false);
    const [commentCount, setCommentCount] = React.useState<number | undefined>(undefined);
    const [fileCount, setFileCount] = React.useState<number | undefined>(undefined);
    const [linkCount, setLinkCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        if (props.selectedTab) {
            setSelectedTab(props.selectedTab);
        }
    }, [props.selectedTab]);

    if (!props.fileReference && !props.linkReference)
        throw new Error('At least one of fileReference, linkReference or commentReference must be provided');

    const tabItems: TabItem2[] = [
        {
            tabName: 'files', 
            text: 'Vedhæftede filer',
            icon: 'interface_actions_attach',
            hidden: !props.fileReference,
            avatarCount: fileCount === undefined ? undefined : fileCount
        },
        {
            tabName: 'links', text: 'Links',
            icon: 'interface_actions_link',
            avatarCount: linkCount === undefined ? undefined : linkCount,
            hidden: !props.linkReference
        }
    ];

    return (

        <PageSectionTabs
            header={{
                tabberProps: {
                    items: tabItems,
                    selectedTabName: selectedTab,
                    onClick: (tabName) => setSelectedTab(tabName as 'files' | 'links' | 'comments')
                },
                customButtonContent:
                    props.commentReference 
                        ?   <Button variant='outlined' icon='comment' size="32px" text={`Vis kommentarer (${commentCount ?? 0})`} onClick={() => setShowComments(true)} />
                        :   undefined,
                defaultCollapsed: false, // Changing this will cause problems since counts will no longer load automatically
                onCollapsedChanged: props.onCollapsedChanged
            }}>

                
            <div>

                {props.fileReference &&
                    <ReferenceFilesPanel
                        modalEditing
                        hide={selectedTab !== 'files'}
                        referenceType={props.fileReference.type}
                        objectId={props.fileReference.id}
                        onGetFilesCount={setFileCount}
                    />
                }

                {props.linkReference &&
                    <ReferenceLinksPanel
                        modalEditing
                        hide={selectedTab !== 'links'}
                        reference={props.linkReference}
                        onGetLinksCount={setLinkCount}
                    />
                }
                {props.commentReference && 
                    <CommentDrawer
                        visible={showComments}
                        onCommentsLoaded={(count) => setCommentCount(count)}
                        onClose={() => setShowComments(false)}
                        reference={{...props.commentReference}}
                    />  
                }
            </div>
        </PageSectionTabs>
    );
}